<template>
  <div>
    <page-list ref='pageList' request-url="/platform/supplier/purchase" :getParams="getQueryParams" :preprocessData="preprocessData">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="10">
            <van-row>
              日期: {{row.purchaseDate}}
            </van-row>
            <van-row>
              状态: <span style="color: #ed8b08;font-size: 13px" v-if="row.status === 1">未结算</span>
              <span style="color: #07c160;font-size: 13px" v-else>已结算</span>
            </van-row>
          </van-col>
          <van-col span="10"><div>金额: {{row.purchaseAmount}}</div></van-col>
          <van-col span="4">
            <van-uploader v-if="row.fileList" v-model="row.fileList" :deletable="false" max-count="1"/>
          </van-col>
        </van-row>
      </template>
    </page-list>
    <van-submit-bar>
      <template #button>
        <van-button type="primary" round block @click.stop="()=>{
          $router.push({name:'purchaseDetail',params: {supplierId:supplierId}})
        }">采购填报</van-button>
      </template>
    </van-submit-bar>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'PurchaseRecordList',
  components: { PageList },
  created () {
    const id = this.$route.params && this.$route.params.supplierId
    if (id) {
      this.supplierId = id
    }
  },
  data () {
    return {
      supplierId: null
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.supplierId = this.supplierId
      // param.status = 1
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    preprocessData (data) {
      data.forEach(item => {
        if (item.purchaseCertificate) {
          item.fileList = [{ url: item.purchaseCertificate, previewSize: 60 }]
        }
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
